import React from "react";
import { Client } from "client";
import { PageSessionId, TrackedRequest } from "./types";
import IPageWrapper from "../../../../utils/pageId";
import { useSelector } from "react-redux";
import { pageConfigSelector } from "../../../PageLayout/reducers/pageLayoutArea";
import last from "lodash/last";
import v4 from "uuid/v4";

export type TrackedRequestsForPageSession = {
    pageSessionId: PageSessionId;
    page: IPageWrapper;
    trackedRequests: ReadonlyArray<TrackedRequest>;
};

export const useMiniProfilerTrackedRequests = (client: Client, enabled: boolean) => {
    const [trackedRequests, setTrackedRequests] = React.useState<TrackedRequestsForPageSession[]>([]);
    const { page } = useSelector(pageConfigSelector);

    React.useEffect(() => {
        return client.subscribeToResponses("miniProfiler", (details) => {
            if (details.miniProfileId.length > 0) {
                if (enabled) {
                    setTrackedRequests((prev) => {
                        const trackedRequest = { originalRequestUrl: details.url, profilerId: details.miniProfileId[details.miniProfileId.length - 1] };
                        const lastPage = last(prev);

                        if (!lastPage || lastPage.page.Id !== page.Id) {
                            return [...prev, { pageSessionId: v4(), page: { ...page }, trackedRequests: [trackedRequest] }];
                        }

                        return [...prev.slice(0, prev.length - 1), { ...lastPage, trackedRequests: [...lastPage.trackedRequests, trackedRequest] }];
                    });
                }
            }
        });
    }, [client, enabled, page]);

    React.useEffect(() => console.log(trackedRequests), [trackedRequests]);

    return { trackedRequests, clearTrackedRequests: () => setTrackedRequests([]) };
};
